import { createContext } from 'react';
import type { BotLimits, ModuleKey } from '../../shared/types/license';

export type LicenseApi = {
  loaded: boolean;
  enforced: boolean;
  canUse(m: ModuleKey): boolean;
  canWrite(m: ModuleKey): boolean;
  clinicReadOnly: boolean;
  botLimits: BotLimits | null;
  /** Licenca valida cancelada: contrato encerrado, vale em observar e aplicar. */
  cut: boolean;
};

/** Sem provider (ou sem licenca que obrigue) a tela e a de sempre. */
export const NOT_ENFORCED: LicenseApi = {
  loaded: true,
  enforced: false,
  canUse: () => true,
  canWrite: () => true,
  clinicReadOnly: false,
  botLimits: null,
  cut: false,
};

export const LicenseContext = createContext<LicenseApi>(NOT_ENFORCED);
